import { createSelector } from 'reselect';

const getReviews = (state) => state.reviews;

const ReviewsSelectors = {
  makeReviewsForListing: createSelector([getReviews], (reviews) => reviews.reviewsForListing),
};

export default ReviewsSelectors;
